import { urlify, splitNewLine } from '../utils/string';

export default (state = {}, action = {}) => {
	if (action.type === 'PRODUCT_CACHE') {
		// Create lookup tables.
		// Sorting done dynamically.

		const possibleSizes = action.sizeConversions.map((s) => urlify(s.base));
		const reverseSizeLookup = action.sizeConversions.reduce((acc, s) => {
			const matches = splitNewLine(s.matches);
			const key = urlify(s.base);
			matches.forEach((m) => {
				if (typeof acc[urlify(m)] === 'undefined') acc[urlify(m)] = [key];
				else acc[urlify(m)].push(key);
			});
			return acc;
		}, {});

		// Name - Search
		const cache = action.productCache.content;
		const { languages, categories, categoryTitles, categoryTitlesLocalized } = action.productCache; // Languages WP setting not Centra.
		const filterArrays = {
			categories, // Object mapping category paths to arrays of product keys.
			sizes: possibleSizes.reduce((acc, s) => ({ ...acc, [s]: [] }), {}), // Object mapping sizes to arrays of product keys.
			productsOnSale: [], // Array of product keys
			newProducts: [], // Array of product keys
		};
		const filterDescriptions = {
			categories: categoryTitles,
			sizes: action.sizeConversions.reduce((acc, s) => ({ ...acc, [urlify(s.base)]: s.base }), {}),
		};
		const languageKeys = Object.keys(languages);
		const searchTerms = languageKeys.reduce((acc, language) => ({ ...acc, [language]: {} }), {});

		const localized = languageKeys.slice(1).reduce((acc, language) => ({
			...acc,
			[language]: {
				categories: categoryTitlesLocalized ? categoryTitlesLocalized[language] : {},
			},
		}), {}); // Merged localized version of above.

		/*
			Localized versions shouldn't create new arrays.
			Their arrays exist but at their non-translated key.
			How to map their keys with their localized versions.
		*/

		Object.keys(cache).forEach((cacheKey) => {
			const item = cache[cacheKey];
			if (item.productHidden) return;

			// Category lookup
			// Categories straight from Centra

			// Search Terms
			searchTerms[languageKeys[0]][item.name] = searchTerms[languageKeys[0]][item.name] ? [...searchTerms[languageKeys[0]][item.name], cacheKey] : [cacheKey];

			if (languageKeys.length > 1) {
				languageKeys.slice(1).forEach((language) => {
					const isoLanguageCode = language;
					const localizedItem = item.localized ? item.localized[isoLanguageCode] : false;

					if (localizedItem && localizedItem.name) {
						searchTerms[isoLanguageCode][localizedItem.name] = searchTerms[isoLanguageCode][localizedItem.name] ? [...searchTerms[isoLanguageCode][localizedItem.name], cacheKey] : [cacheKey];
					} else {
						searchTerms[isoLanguageCode][item.name] = searchTerms[isoLanguageCode][item.name] ? [...searchTerms[isoLanguageCode][item.name], cacheKey] : [cacheKey];
					}
				});
			}

			// Sizes lookup
			Object.keys(item.sizes).forEach((sizeKey) => {
				const sizeItem = item.sizes[sizeKey];
				let sizeKeyUrlified = urlify(sizeItem.name);
				if (possibleSizes.indexOf(sizeKeyUrlified) === -1) {
					sizeKeyUrlified = reverseSizeLookup[sizeKeyUrlified] ? reverseSizeLookup[sizeKeyUrlified] : [];
				} else {
					sizeKeyUrlified = [sizeKeyUrlified];
				}

				sizeKeyUrlified.forEach((s) => {
					if (sizeItem.stock === 0) return;
					filterArrays.sizes[s][filterArrays.sizes[s].length] = cacheKey;

					if (item.relatedSizes) {
						item.relatedSizes.forEach((relatedSize) => {
							filterArrays.sizes[s][filterArrays.sizes[s].length] = relatedSize;
						});
					}
				});
			});

			// Sale / News
			if (item.price.showAsOnSale) filterArrays.productsOnSale[filterArrays.productsOnSale.length] = cacheKey;
			if (item.price.newProduct) filterArrays.newProducts[filterArrays.newProducts.length] = cacheKey;
		});

		/*
			Extend search terms.
		*/

		// Categories
		Object.keys(filterDescriptions.categories).forEach((category) => {
			const categorySearchTerm = searchTerms[languageKeys[0]][filterDescriptions.categories[category]];
			searchTerms[languageKeys[0]][filterDescriptions.categories[category]] = !categorySearchTerm ? filterArrays.categories[category] : [...categorySearchTerm, ...filterArrays.categories[category]];

			if (languageKeys.length > 1) {
				languageKeys.slice(1).forEach((language) => {
					if (localized[language] && localized[language].categories && localized[language].categories[category]) {
						const localizedCategorySearchTerm = searchTerms[language][localized[language].categories[category].description];
						searchTerms[language][localized[language].categories[category].description] = !localizedCategorySearchTerm ? filterArrays.categories[category] : [...localizedCategorySearchTerm, ...filterArrays.categories[category]];
					} else {
						const localizedCategorySearchTerm = searchTerms[language][filterDescriptions.categories[category]];
						searchTerms[language][filterDescriptions.categories[category]] = !localizedCategorySearchTerm ? filterArrays.categories[category] : [...localizedCategorySearchTerm, ...filterArrays.categories[category]];
					}
				});
			}
		});

		return {
			...state,
			[action.market]: {
				...state[action.market],
				[action.pricelist]: {
					products: cache,
					filterArrays,
					filterDescriptions,
					localized,
					searchTerms,
				},
			},
		};
	}

	return state;
};
